import script from "./SecurityInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurityInfo.vue?vue&type=script&setup=true&lang=ts"

import "./SecurityInfo.vue?vue&type=style&index=0&id=2962fe92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2962fe92"]])

export default __exports__